import OneDriveIcon from '../../../../../images/office-365-icons/one-drive.svg';
import SharePointIcon from '../../../../../images/office-365-icons/sharepoint.png';
import OutlookIcon from '../../../../../images/accounts-icons/outlook-icon.svg';
import CalendarIcon from '../../../../../images/office-365-icons/calendar.svg';
import ContactIcon from '../../../../../images/office-365-icons/contacts.svg';
import TeamsIcon from '../../../../../images/accounts-icons/teams.svg';
import OneNoteIcon from '../../../../../images/office-365-icons/onenote-2.svg';
import styled from 'styled-components';

interface OfficeIconsProps{
  type: string,
  noMargin?: boolean,
}

interface typeMappingProps{
  [key:string]: any,
}

const Container = styled.div`
  display: inline-block;
  margin-left: 10px;
  &.noMargin{
    margin-left: 0;
  }
  & img{
    vertical-align: middle;
    max-width: 100%;
  }
`

const typeMapping:typeMappingProps = {
  onedrive: OneDriveIcon,
  sharepoint: SharePointIcon,
  outlook: OutlookIcon,
  calendar: CalendarIcon,
  contacts: ContactIcon,
  teams: TeamsIcon,
  onenote: OneNoteIcon,
}

const OfficeIcon = ({ type, noMargin }: OfficeIconsProps) => {
  if (!typeMapping[type]) {
    return null;
  }

  return (
    <Container className={noMargin ? 'noMargin' : ''}>
      <img src={typeMapping[type]} alt={`${type} icon`} />
    </Container>
  )
}

export default OfficeIcon;